import { ITreasuryData, ITreasuryDetails } from '@common/interfaces/treasury'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

export default combineReducers({
  treasuryData: createLoadingDataReducer<ITreasuryData>(
    [actions.LIST_TREASURY_REQUEST],
    [actions.UPDATE_TREASURY_REQUEST],
  ),
  fundingWires: createLoadingDataReducer<{ data: ITreasuryDetails[] }>(
    [actions.LIST_TREASURY_FUNDING_WIRES_REQUEST],
    [actions.UPDATE_TREASURY_REQUEST],
  ),
  otherWires: createLoadingDataReducer<{ data: ITreasuryDetails[] }>(
    [actions.LIST_TREASURY_OTHER_WIRES_REQUEST],
    [actions.UPDATE_TREASURY_REQUEST],
  ),
  participationWires: createLoadingDataReducer<{ data: ITreasuryDetails[] }>(
    [actions.LIST_TREASURY_PARTICIPATION_WIRES_REQUEST],
    [actions.UPDATE_TREASURY_REQUEST],
  ),
  passthroughWires: createLoadingDataReducer<{ data: ITreasuryDetails[] }>(
    [actions.LIST_TREASURY_PASSTHROUGH_WIRES_REQUEST],
    [actions.UPDATE_TREASURY_REQUEST],
  ),
})
